export default __webpack_public_path__ + "static/media/slide4.a8499779.png";